import React from 'react';
import PropTypes from "prop-types";

const MediaAndText = ({image, imgCaption, imgAlt, paragraph, elClass}) => {

	return (
		<div className={`${elClass} main-grid`}>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<div className={`${elClass}__wrapper`}>
					<figure>
						<img src={image} alt={imgAlt}/>
						<figcaption className='img-caption' dangerouslySetInnerHTML={{__html: imgCaption}}></figcaption>
					</figure>
					<div className={`${elClass}__text-container`} dangerouslySetInnerHTML={{__html: paragraph}}>
					</div>
				</div>
			</div>
			<div className='main-grid__margin'></div>			
		</div>
	)
}

export default MediaAndText;

MediaAndText.propTypes = {
	image: PropTypes.string,
	imgCaption: PropTypes.string,
	imgAlt: PropTypes.string,
	paragraph: PropTypes.string,
	elClass: PropTypes.string,
};